
namespace TabAurous.ECommerce {

    @Serenity.Decorators.registerClass()
    export class ECommSalesReturnTaxGrid extends Serenity.EntityGrid<ECommSalesReturnTaxRow, any> {
        protected getColumnsKey() { return 'ECommerce.ECommSalesReturnTax'; }
        protected getIdProperty() { return ECommSalesReturnTaxRow.idProperty; }
        protected getInsertPermission() { return ECommSalesReturnTaxRow.insertPermission; }
        protected getLocalTextPrefix() { return ECommSalesReturnTaxRow.localTextPrefix; }
        protected getService() { return ECommSalesReturnTaxService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}